import React from 'react'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'

import {
  formContainer,
  titleContainer,
  mainTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'

const ChangePasswordForm = ({ onSubmit, translation, lang }) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmationPT : validators.passwordConfirmationES
  const { control, getValues, handleSubmit } = useForm({
    defaultValues: {
      password: '',
      password_confirmation: ''
    }
  })

  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h1 className={mainTitle}>{translation('changePasswordForm')['passwordFormTitle']}</h1>
      </header>

      <div>
        <Input
          control={control}
          name='password'
          rules={{ validate: validators.composeValidators(required, passwordLength) }}
          placeholder={translation('changePasswordForm')['newPasswordPlaceholder']}
          type='password'
          block
        />

        <Input
          control={control}
          name='password_confirmation'
          rules={{ validate: validators.composeValidators(required, passwordConfirmation(getValues)) }}
          placeholder={translation('changePasswordForm')['confirmPasswordPlaceholder']}
          type='password'
          block
        />
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
        >
          {translation('changePasswordForm')['changeButton']}
        </Button>
      </div>
    </form>
  )
}

ChangePasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  translation: PropTypes.func,
  lang: PropTypes.string
}

export default ChangePasswordForm
